export default __webpack_public_path__ + "static/media/help_02.6fc44221.jpg";